import { useState, useCallback } from "react";
import { omit } from "lodash";

const useControlledRowSelection = () => {
  const [selectedRows, setSelectedRows] = useState({});

  const updateControlledSelection = useCallback(
    (rowIds, checked) => {
      if (!checked) {
        setSelectedRows(omit(selectedRows, rowIds));
      } else {
        const rowIdsToAdd = rowIds.reduce(
          (rows, rowId) => ({ ...rows, [rowId]: true }),
          {}
        );
        setSelectedRows({ ...selectedRows, ...rowIdsToAdd });
      }
    },
    [selectedRows]
  );

  const resetSelectedRows = () => {
    setSelectedRows({});
  };

  return {
    updateControlledSelection,
    resetSelectedRows,
    selectedRows
  };
};

export default useControlledRowSelection;
